import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography, Box, Alert, CircularProgress } from '@mui/material';
import { api } from '../../services/apiClient';
import Wordmark from '../../components/common/Wordmark';

const SSOLoginPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<string>('Signing you in...');

  useEffect(() => {
    const handleSSOLogin = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (!token) {
        setError('No SSO token provided. Please try again from the LMS.');
        return;
      }

      try {
        const response = await api.post<{
          user: any;
          token: string;
          refreshToken: string;
          expiresIn: string;
        }>('/auth/sso-login', { token });

        localStorage.setItem('authToken', response.token);
        setStatus('Login successful! Redirecting...');
        window.location.href = '/dashboard';
      } catch (err: any) {
        const message =
          err?.message ||
          err?.response?.data?.message ||
          'SSO login failed. The link may have expired.';
        setError(message);
      }
    };

    handleSSOLogin();
  }, []);

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 12,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box component="h1" sx={{ m: 0, mb: 3 }}>
            <Wordmark size={44} tone="light" />
          </Box>

          {error ? (
            <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
              {error}
            </Alert>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 2 }}>
              <CircularProgress />
              <Typography variant="body1" color="text.secondary">
                {status}
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default SSOLoginPage;
